(() => {
  if (window.topicsExperienceReady) return;
  window.topicsExperienceReady = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root = document) {
    root.querySelectorAll('[data-tf-edit]').forEach(edit => {
      if (edit.dataset.ready) return;
      edit.dataset.ready = 'true';
      edit.querySelector('.tf-edit-controls').hidden = false;
      edit.addEventListener('click', event => {
        const button = event.target.closest('[data-tf-look]');
        if (!button || !edit.contains(button)) return;
        edit.querySelectorAll('[data-tf-look]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
        edit.querySelectorAll('[data-tf-look-panel]').forEach(panel => {
          panel.hidden = panel.dataset.tfLookPanel !== button.dataset.tfLook;
          panel.toggleAttribute('data-tf-active', !panel.hidden && !motion.matches);
        });
        edit.querySelector('[data-tf-look-status]').textContent = button.textContent.trim() + ' geselecteerd.';
      });
    });
    if (!motion.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Content stays visible without JS or if the observer fails.
            entry.target.classList.add('tf-entered');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: .12});
      root.querySelectorAll('.tf-section-heading,.tf-edit-heading,.tf-store-copy,.tf-advice-intro,.tf-product,.tf-category,.tf-hero-copy,.tf-hero-photo,.tf-review-card,.tf-shot-board').forEach(el => observer.observe(el));
    }
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  const progress = document.createElement('div');
  progress.className = 'tf-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.append(progress);
  let scheduled = false;
  function paint() {
    const range = document.documentElement.scrollHeight - innerHeight;
    progress.style.transform = `scaleX(${range > 0 ? Math.min(1, Math.max(0, scrollY / range)) : 0})`;
    scheduled = false;
  }
  addEventListener('scroll', () => { if (!scheduled && !motion.matches) { scheduled = true; requestAnimationFrame(paint); } }, {passive: true});
  addEventListener('resize', paint);
  paint();
})();

// Delegation also covers sections reloaded inside the theme editor.
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-tf-review-pause]');
 if(!button)return;
 const section=button.closest('[data-tf-reviews]');
 const paused=section.dataset.paused!=='true';
 section.dataset.paused=String(paused);
 button.setAttribute('aria-pressed',String(paused));
 button.textContent=paused?'Hervat beweging':'Pauzeer beweging';
});
